import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import RCDetailsOutputComponent from '../output/RCDetailsOutputComponent';

const RCDetailsInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-car', title: 'RC Details Verification', subtitle: 'Verify vehicle registration certificate details via Gridlines' }}
        fields={[
            { name: 'rc_number', label: 'RC Number', icon: 'pi-id-card', placeholder: 'MH01AB1234', maxLength: 12, autoCapitalize: 'characters', spellCheck: false, uppercase: true, mono: true,
              regex: /^[A-Z]{2}\d{1,2}[A-Z]{1,3}\d{1,4}$/, regexError: 'Enter a valid RC format (e.g., MH01AB1234)' },
            { name: 'phone', label: 'Mobile (optional)', icon: 'pi-phone', placeholder: '9876543210', maxLength: 10, inputMode: 'tel', numeric: true, mono: true, required: false },
            { name: 'pan', label: 'PAN (optional)', icon: 'pi-credit-card', placeholder: 'ABCDE1234F', maxLength: 10, autoCapitalize: 'characters', spellCheck: false, uppercase: true, mono: true, required: false },
        ]}
        endpoint={{
            path: '/gridlines/rc-details',
            bodyMapper: (v, sid) => ({
                rc_number: v.rc_number,
                consent: 'Y',
                ...(v.phone && { phone: v.phone }),
                ...(v.pan && { pan: v.pan }),
                api_provider_service_id: parseInt(sid, 10),
            }),
        }}
        consentReportType="rc-details"
        submitLabel="Fetch RC Details"
        successSummary="RC details fetched"
        errorSummary="RC details fetch failed"
        confirmHeader="Confirm RC details fetch"
        confirmAcceptLabel="Yes, fetch"
        outputComponent={RCDetailsOutputComponent}
        pdfEndpoint={(reportId) => `/gridlines/rc-details/${reportId}/generate-pdf`}
        pdfPasswordHint='PDF is password protected — use the last 4 characters of the RC number + "RC" (e.g. 1234RC).'
    />
);

export default RCDetailsInputComponent;
